import React from "react";
import { apiUrl, fbAuth } from "./util";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Login from "./containers/Login";
import Reset from "./containers/Reset";
import Files from "./containers/Files";
import SemFiles from "./containers/SemFiles";
import ScreenShots from "./containers/ScreenShots";
import SemScreenShots from "./containers/SemScreenShots";
import Urls from "./containers/Urls";
import UrlScreenShots from "./containers/UrlScreenShots";
import UrlTests from "./containers/UrlTests";
import Queue from "./containers/Queue";
import ProblemQueue from "./containers/ProblemQueue";
import QueueByCompany from "./containers/QueueByCompany";
import QueueForCompany from "./containers/QueueForCompany";
import RecentQueue from "./containers/RecentQueue";
import UrlQueue from "./containers/UrlQueue";
import ManualCaptureQueue from "./containers/ManualCaptureQueue";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import AutoAssignedQueue from "./containers/AutoAssignedQueue";
import request from "request";
import AutoAssignedQueueForCompany from "./containers/AutoAssignedQueueForCompany";

const PrivateRoute = ({
  component: Component,
  authed,
  user,
  queue,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      return authed === true ? (
        <Component queue={queue} user={user} {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      );
    }}
  />
);
const USER_ACTIVITY_TRACKING_INTERVAL = 1 * 60 * 1000;
const USER_REFRESH_TOKEN_INTERVAL = 30 * 60 * 1000;
class App extends React.Component {
  state = {
    loading: true,
    user: null,
    authed: false,
  };
  time = new Date().getTime();
  visibleEvent = () => {
    if (!document.hidden) {
      const newTime = new Date().getTime();
      clearInterval(this.trackUser);
      if (newTime - this.time >= USER_ACTIVITY_TRACKING_INTERVAL) {
        //this.getUserData(this.state.user, true);
        this.trackUserActivity(this.state.user);
        this.time = newTime;
      }
      this.trackUser = setInterval(() => {
        this.trackUserActivity(this.state.user);
      }, USER_ACTIVITY_TRACKING_INTERVAL);
    } else {
      clearInterval(this.trackUser);
    }
  };
  componentDidMount() {
    this.refresh = setInterval(() => {
      this.getUserData(this.state.user);
    }, USER_REFRESH_TOKEN_INTERVAL);
    this.trackUser = setInterval(() => {
      this.trackUserActivity(this.state.user);
    }, USER_ACTIVITY_TRACKING_INTERVAL);
    this.removeListener = fbAuth.onAuthStateChanged(async user => {
      this.getUserData(user);
    });
    document.addEventListener("visibilitychange", this.visibleEvent);
  }
  getUserData = async user => {
    if (user) {
      const token = await user.getIdToken(true);
      user.token = token;
      this.setState({
        loading: false,
        authed: true,
        user,
      });
      // A fresh token: resume tracking if a 401 stopped it.
      clearInterval(this.trackUser);
      this.trackUser = setInterval(() => {
        this.trackUserActivity(this.state.user);
      }, USER_ACTIVITY_TRACKING_INTERVAL);
    } else {
      this.setState({
        loading: false,
        authed: false,
        user: null,
      });
    }
  };
  trackUserActivity = async user => {
    // A hidden tab isn't activity. Tabs opened in the background never fire
    // visibilitychange, so the interval alone kept them polling for days.
    if (document.hidden || !user || !user.token) {
      return;
    }
    request(
      {
        url: `${apiUrl}/v1/t?url=${window.location.href}`,
        headers: {
          Authorization: user.token,
        },
      },
      (err, res) => {
        // The token stays expired until the next refresh; stop polling until then.
        if (res && res.statusCode === 401) {
          clearInterval(this.trackUser);
        }
      }
    );
  };
  componentWillUnmount() {
    this.removeListener();
    document.removeEventListener("visibilitychange", this.visibleEvent);
    clearInterval(this.trackUser);
    clearInterval(this.refresh);
  }
  removeListener = () => {};
  refresh = () => {};
  trackUser = () => {};
  render() {
    const { loading, authed, user } = this.state;
    if (user) {
      this.trackUserActivity(user);
    }
    return (
      <Router>
        <div className="App">
          {loading ? (
            <h1>Loading...</h1>
          ) : (
            <>
              <Route
                path="/"
                exact
                render={props => (
                  <Login {...props} user={user} authed={authed} />
                )}
              />
              <Route
                path="/reset"
                exact
                render={props => (
                  <Reset {...props} user={user} authed={authed} />
                )}
              />
              <PrivateRoute
                exact
                path="/urls"
                component={Urls}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/sem"
                component={SemFiles}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/sem/:date"
                component={SemFiles}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/sem/:date/:all"
                component={SemFiles}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/files"
                component={Files}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/files/:date"
                component={Files}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/files/:date/:all"
                component={Files}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/semss/:id/:ctime"
                component={SemScreenShots}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/semss/:id/:ctime/:url"
                component={SemScreenShots}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/ss/:id/:ctime"
                component={ScreenShots}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/screens/:url"
                component={UrlScreenShots}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/screens/:url/tests"
                component={UrlTests}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/ended"
                component={Queue}
                queue="ended"
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/started"
                component={Queue}
                queue="new"
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/urls"
                component={UrlQueue}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/qa"
                component={Queue}
                queue="qa"
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/problem"
                component={ProblemQueue}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/manual"
                component={ManualCaptureQueue}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/recent"
                component={RecentQueue}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/company"
                component={QueueByCompany}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/company/:company"
                component={QueueForCompany}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/auto/company"
                component={AutoAssignedQueue}
                authed={authed}
                user={user}
              />
              <PrivateRoute
                exact
                path="/queue/auto/company/:company"
                component={AutoAssignedQueueForCompany}
                authed={authed}
                user={user}
              />
            </>
          )}
        </div>
      </Router>
    );
  }
}

export default App;
